import { ApiResponse } from 'app/types-shared';
import { RemoteAdminData } from 'app/infrastructure/remote-data/remote-data';
import { CodetableWireFormat } from 'app/infrastructure/ui/form/types-codetable';
import { endpoints } from './endpoints';
import { CodeListWire, LoadCodeItemsParams } from './types';
import { CodesAccessWire, CodetablesAccessWire } from 'app/area/indicator-factors/types-store';
import { CodeListModifiedItem, DuplicateRowsWire } from 'app/area/indicator-factors/list/types-store';
import { FilterSearchModel } from 'app/area/search-filters/types-store';

export const api = {

  loadCodeItems: async (loadParams: LoadCodeItemsParams): Promise<CodeListWire> => {

    const { id, parentId, siblingId, categoryId, query, displayNotSelected, startIndex, maxResults,
      limitFieldsTo, includeInactiveCodes, ignoreCategoryFilters, includeNotSelected, code, model } = loadParams;

    const response = await new RemoteAdminData(endpoints.optionsCollection(id)).resource<Response>()
      .filter({
        'api-version': '3.0',
        ...(startIndex !== undefined && { startIndex }),
        ...(maxResults !== undefined && { maxResults }),
        ...(parentId !== undefined && { parentId }),
        ...(siblingId !== undefined && { siblingId }),
        ...(displayNotSelected !== undefined && { displayNotSelected }),
        ...(includeNotSelected !== undefined && { includeNotSelected })
      })
      .create({
        ...(includeInactiveCodes && !model && { includeInactiveCodes }),
        ...(limitFieldsTo && { limitFieldsTo }),
        ...(ignoreCategoryFilters && { ignoreCategoryFilters }),
        ...(!!query && {
          query: {
            text: query
          }
        }),
        ...(code && { code }),
        ...(categoryId !== undefined && {
          category: {
            selectedIds: [
              {
                v: categoryId
              }
            ]
          }
        }),
        ...model
      });

    const json = await response.json();

    return json.data;
  },

  loadPath: async (codetableId: number, codeId: number): Promise<CodetableWireFormat> => {

    const response = await new RemoteAdminData(endpoints.optionPath(codetableId, codeId))
      .resource<ApiResponse<CodetableWireFormat>>()
      .single();

    return response.data;
  },

  deleteCodeItem: async (codetableId: number, codeId: number): Promise<any> => {
    return await new RemoteAdminData(endpoints.deleteCodeItem(codetableId, codeId))
      .resource<ApiResponse<any>>()
      .httpDelete({});
  },

  loadCodesAccess: async (codetableId: number, codeId: number): Promise<CodesAccessWire> => {
    const request = await new RemoteAdminData(endpoints.codesAccess(codetableId))
      .resource<ApiResponse<CodesAccessWire>>()
      .filter({ id: codeId })
      .single();
    return request.data;
  },

  loadCodesAccesses: async (codetableId: number, codeIds: number[]): Promise<CodesAccessWire> => {
    const request = await new RemoteAdminData(endpoints.codesAccess(codetableId))
      .resource<ApiResponse<CodesAccessWire>>()
      .filter({ id: codeIds })
      .all();
    return request.data;
  },

  loadCodetablesAccess: async (codetableId: number): Promise<CodetablesAccessWire> => {
    const request = await new RemoteAdminData(endpoints.codetablesAccess)
      .resource<ApiResponse<CodetablesAccessWire>>()
      .filter({ id: codetableId })
      .single();
    return request.data;
  },

  duplicateRows: async (data: DuplicateRowsWire) => {
    const request = await new RemoteAdminData(endpoints.duplicateRows)
      .resource<ApiResponse<CodetablesAccessWire>>()
      .filter({ 'api-version': '3.0' })
      .create(data);

    return request.data;
  },

  deleteRows: async (codetableId: number, model: FilterSearchModel) => {
    const request = await new RemoteAdminData(endpoints.deleteRows(codetableId))
      .resource<ApiResponse<CodetablesAccessWire>>()
      .filter({ 'api-version': '3.0' })
      .httpDelete(model);

    return request.data;
  },

  saveChanges: (modifiedItems: CodeListModifiedItem[]) => {

    return new RemoteAdminData(endpoints.saveFactors)
      .resource<void>()
      .update(modifiedItems);
  }
};
